import React, { FC } from 'react';

import AndroidInterestText from './AndroidInterestText';
import { ReactComponent as SelectedAppleMusic } from 'icons/playlistDsp/appleMusic-white.svg';

import { Wrapper, MainText, SubText, Button } from './styles';

interface IProps {
  ON_linkUrl?: string;
  openModal: () => void;
}

const IOSSection: FC<IProps> = ({ ON_linkUrl, openModal }) => {
  return (
    <Wrapper>
      <MainText>Get the New OPUS Notifier App for iPhone</MainText>
      <SubText>1. Download the app</SubText>
      <Button href={ON_linkUrl}>
        <SelectedAppleMusic /> Download Notifier App
      </Button>
      <SubText>
        2. Follow instructions to start receiving push notifications
      </SubText>
      <Button onClick={openModal}>Installation Instructions</Button>
      <AndroidInterestText isSmallScreen />
    </Wrapper>
  );
};

export default IOSSection;
